import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "py-2.5 font-bold" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["target", "href"]

import ListItem from "./ListItem.vue";
import useMostSuggestedRequest from "@/composables/use-most-suggested-request";
import useSearch from "@/composables/use-search";


export default /*#__PURE__*/_defineComponent({
  __name: 'FindingsMostSuggested',
  setup(__props) {

const { resetSearch } = useSearch();
const { mostSuggestedItems, hasMostSuggestedItems } = useMostSuggestedRequest();

const routeToSearchResults = (event: Event) => {
	window.ocmOrchestrator && window.ocmOrchestrator.spaNavigateUrl(event);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(mostSuggestedItems).headline), 1),
    (!_unref(hasMostSuggestedItems))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Loading …"))
      : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(mostSuggestedItems).mostSearchItems, (item, i) => {
          return (_openBlock(), _createElementBlock("a", {
            key: `mostSuggested-${i}`,
            target: item.sameWindow ? '_self' : '_blank',
            href: item.url,
            class: "-mx-4 block px-4 font-normal hover:bg-gray-20",
            onClick: _cache[0] || (_cache[0] = ($event: any) => {
				routeToSearchResults($event);
				_unref(resetSearch)();
			})
          }, [
            _createVNode(ListItem, {
              text: item.linkName
            }, null, 8, ["text"])
          ], 8, _hoisted_3))
        }), 128))
  ], 64))
}
}

})